<template>
  <footer class="footer-wrapper">
    <div class="footer-container">
      <!-- 左侧：公司信息 -->
      <div class="footer-section company-brand">
        <router-link to="/" class="footer-logo">
          <img src="../assets/images/logo.png" alt="" />
        </router-link>
        <h3 class="company-name">广西保辰信息科技有限公司</h3>
        <p class="copyright">Copyright © 2024 保辰信息-官方网站</p>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" class="beian">
          桂ICP备2022006656号
        </a>
      </div>

      <!-- 中间：快速导航 -->
      <div class="footer-section footer-nav">
        <h4 class="section-title">快速导航</h4>
        <nav class="nav-links">
          <router-link to="/">首页</router-link>
          <router-link to="/invitation">广西招投标公告</router-link>
          <router-link to="/camodule">西部CA办理入口</router-link>
          <router-link to="/projectservices">服务项目</router-link>
          <router-link to="/news">新闻资讯</router-link>
          <router-link to="/about">关于我们</router-link>
        </nav>
      </div>

      <!-- 右侧：联系我们 -->
      <div class="footer-section contact-info">
        <h4 class="section-title">联系我们</h4>
        <div class="contact-content-wrapper">
          <div class="contact-details">
            <p class="contact-item">
              <span class="label">{{ info.address.webContentTitle }}</span>
              <span class="value">{{ info.address.webContentText }}</span>
            </p>
            <p v-if="info.address2.webContentText" class="contact-item">
              <span class="label">{{ info.address2.webContentTitle }}</span>
              <span class="value">{{ info.address2.webContentText }}</span>
            </p>
            <p class="contact-item">
              <span class="label">{{ info.phone.webContentTitle }}</span>
              <span class="value">{{ info.phone.webContentText }}</span>
            </p>
            <div class="mobile-group">
              <p class="contact-item value">{{ info.mobile.webContentText }}</p>
              <p class="contact-item value">
                {{ info.mobile2.webContentText }}
              </p>
            </div>
          </div>
          <div class="qr-codes">
            <div class="qr-item" v-for="(item, index) in imgList" :key="index">
              <el-image
                :src="item.picLoad"
                :preview-src-list="imgList.map((i) => i.picLoad)"
                fit="contain"
              />
              <span>{{ item.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import article from "@/api/article";
export default {
  name: "Footer",
  data() {
    return {
      info: {
        address: { webContentText: "", webContentTitle: "" },
        address2: { webContentText: "", webContentTitle: "" },
        phone: { webContentText: "", webContentTitle: "" },
        msg: { webContentText: "", webContentTitle: "" },
        mobile: { webContentText: "", webContentTitle: "" },
        mobile2: { webContentText: "", webContentTitle: "" },
      },
      imgList: [],
    };
  },
  mounted() {
    this.handleGetData();
    this.getBannerList();
  },
  methods: {
    handleGetData() {
      article
        .aboutData({ belongPage: "about" })
        .then((res) => {
          const records = res.data.data.records;
          records.forEach((item) => {
            if (
              [
                "Email",
                "locahost",
                "phone",
                "mobile",
                "mobile2",
                "address2",
                "address",
                "connect",
              ].includes(item.notes)
            ) {
              item.webContentText = item.webContentText.replace(/<[^>]*>/g, "");
            }
            this.info[item.notes] = item;
          });
        })
        .catch((error) => console.error(error));
    },
    getBannerList() {
      article.bannerList({ belongPage: "foot" }).then((res) => {
        this.imgList = res.data.data.records;
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/styles/variables.less";

.footer-wrapper {
  background-color: #1e293b;
  color: #f1f5f9;
  padding: 25px 30px 20px; // 增加左右内边距，确保在大屏下不贴边
  margin-top: 30px;
}

.footer-container {
  display: grid;
  grid-template-columns: 240px 120px 1fr;
  gap: 30px;
  max-width: 1400px; // 相比 container-fixed 的 1200px，使用更宽的容器
  margin: 0 auto; // 居中
}

.footer-section {
  display: flex;
  flex-direction: column;
}

.footer-logo {
  height: 40px;
  margin-bottom: 12px;
  img {
    height: 100%;
    width: auto;
    filter: brightness(0) invert(1);
  }
}

.company-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #ffffff;
  white-space: nowrap; // 防止公司名换行
}

.copyright,
.beian {
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 4px;
  white-space: nowrap; // 防止版权信息和备案号换行
}

.beian:hover {
  color: @primary-color;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 12px; // 减小标题下间距
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -4px; // 调整装饰线位置
    left: 0;
    width: 28px;
    height: 2px;
    background-color: @primary-color;
    border-radius: 2px;
  }
}

.nav-links {
  display: flex;
  flex-direction: column;
  gap: 6px; // 减小导航链接间距
  flex-shrink: 0;

  a {
    font-size: 13px;
    color: #94a3b8;
    white-space: nowrap;
    &:hover {
      color: @primary-color;
      transform: translateX(4px);
    }
  }
}

.contact-content-wrapper {
  display: flex;
  gap: 25px; // 减小内容和二维码间距
  align-items: flex-start;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 4px; // 减小联系项间距
  flex: 1;

  .contact-item {
    font-size: 13px;
    color: #94a3b8;
    line-height: 1.3; // 进一步压缩行高
    white-space: nowrap;

    .label {
      color: #cbd5e1;
      font-weight: 500;
      margin-right: 6px;
    }
  }

  .mobile-group {
    display: flex;
    gap: 10px; // 减小手机号间距
    margin-top: 1px;
  }
}

.qr-codes {
  display: flex;
  gap: 15px; // 减小二维码间距
  flex-shrink: 0;

  .qr-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px; // 减小二维码和文字间距
    flex-shrink: 0;

    /deep/ .el-image {
      width: 65px; // 略微减小二维码尺寸
      height: 65px;
      min-width: 65px;
      padding: 3px;
      background: #ffffff;
      border-radius: 4px;
      object-fit: contain;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    span {
      font-size: 10px; // 略微减小二维码文字
      color: #94a3b8;
    }
  }
}

@media (max-width: 992px) {
  .footer-container {
    grid-template-columns: 1fr;
    gap: 48px;
  }
}
</style>
